module.exports = __webpack_public_path__ + "static/media/homeinsurancepennymac.5d69a562.svg";